import React from 'react'
import { List, Button, Card, Label } from 'semantic-ui-react'
import _ from 'lodash'

const styles = {
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
}

const Row = ({ name, price, }) => {
  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ display: 'flex', flex: 1 }}>
          {name}
        </div>

        <div style={{ display: 'flex' }}>
          <Label size="small">
            $ {price}
          </Label>
        </div>
      </List.Content>
    </List.Item>
  )
}

const CrossSellItemCard = ({ onEdit, onDelete, items, data, branchName }) => {
  const { item_ids: itemIds } = data
  return (
    <Card>
      <Card.Content>
        <Card.Header>{branchName}</Card.Header>
        <Card.Meta>Items ({_.size(itemIds)})</Card.Meta>
        <Card.Description style={{ paddingRight: 10, minHeight: 200, maxHeight: 250, overflow: 'auto'}}>
          <List divided verticalAlign='middle' style={{ marginTop: 10 }}>
            {itemIds.map(id => {
              const itemName = _.get(items, [id, 'name'], 'Item Not Found')
              const itemPrice = _.get(items, [id, 'current_price'], 'N/A')

              return (
                <Row name={itemName} price={itemPrice} key={id} />
              )
            })}
          </List>
        </Card.Description>
      </Card.Content>

      <Card.Content extra textAlign='right' >
        <Button color='black' size="tiny" onClick={onEdit}>Edit</Button>
        <Button color='red' size="tiny" onClick={onDelete}>Delete</Button>
      </Card.Content>
    </Card>
  )
}

export default CrossSellItemCard


// WEBPACK FOOTER //
// ./src/components/restaurants/views/CrossSellItemCard.js